// 移除空字符串，null, undefined,[],{}
export function clearEmptyParam(_param) {
    if (_param) {
        const param = { ..._param };
        const keys = Object.keys(param);
        if (keys.length) {
            keys.forEach((key) => {
                const value = param[key];
                const rawType = toRawType(value);
                if (rawType === 'Array' && value?.length === 0) {
                    delete param[key];
                }
                if (rawType === 'Object' && JSON.stringify(value) === '{}') {
                    delete param[key];
                }
                if (['', undefined, null].includes(value)) {
                    delete param[key];
                }
            });
        }
        return param;
    }
    return {};
}
/**
 * @description 获取原始类型
 * @param {*} value
 * @returns {String} 类型字符串，如'String', 'Object', 'Null', 'Boolean', 'Number', 'Array'
 */
export function toRawType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
/**
 * @description 判空
 * @param {*} value
 * @returns {boolean} true:不为空，false:为空
 */
export function hasContent(value) {
    if (!value) {
        return false;
    }
    const rawType = toRawType(value);
    return !((rawType === 'Array' && value?.length === 0) ||
        (rawType === 'Object' && JSON.stringify(value) === '{}'));
}
export const isFunction = (value) => typeof value === 'function';
export const isUndef = (value) => typeof value === 'undefined';
